<template>
  <div id="mutualHelpList">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item label="投放状态">
          <el-select
            v-model="formInline.LaunchState"
            placeholder="请选择投放状态"
          >
            <el-option
              v-for="item in LaunchStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问卷状态">
          <el-select
            v-model="formInline.QuestionnaireState"
            placeholder="请选择问卷状态"
          >
            <el-option
              v-for="item in QuestionnaireStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放开始时间">
          <el-date-picker
            clearable
            value-format="yyyy-MM-dd"
            v-model="formInline.LaunchStartDate"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="投放截止时间">
          <el-date-picker
            v-model="formInline.LaunchEndDate"
            clearable
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="文本查询">
          <el-input
            placeholder="请输入内容"
            clearable
            v-model="formInline.SearchTerm"
          >
            <!-- <el-button
              @click="getQuesList"
              slot="append"
              icon="el-icon-search"
            ></el-button> -->
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width:98px"
            type="primary"
            @click="handleCurrentChange(1)"
          >查询</el-button>
          <el-button
            style="width:98px"
            type="danger"
            plain
            @click="reset"
          >重置</el-button>
        </el-form-item>
        <el-form-item
          label=""
          style="float:right"
        >
          <!-- <el-button
            :disabled="batchFlog"
            @click="launch(multipleIds)"
            style="width:98px"
            type="primary"
          >批量投放</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <!-- <el-table
        v-loading="loading"
        :data="quesList"
        :height="tableH"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      > -->
      <el-table
        v-loading="loading"
        :data="quesList"
        :height="tableH"
        border
        style="width: 100%"
      >
        <!-- <el-table-column
          align="center"
          type="selection"
          width="55"
        >
        </el-table-column> -->
        <el-table-column
          fixed
          header-align="center"
          prop="questionnaireTitle"
          label="问卷标题"
          width="250"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalPrice"
          label="投放总金额(元)"
          width="180"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="price"
          label="单个红包金额(元)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="amount"
          label="投放红包个数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="amountOfSend"
          label="已发出的红包数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="amountOfRemain"
          label="剩余红包数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="dateOfLaunch"
          label="投放开始时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="dateOfStopLaunch"
          label="投放截止时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="topDeadLine"
          label="投放置顶时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="投放状态"
        >
          <template slot-scope="scope">
            <template v-for="(item,index) in LaunchStateList">
              <span
                :key="index"
                :style="{color:item.color}"
                v-if="item.value==scope.row.questionnaireLaunchState"
              >{{ item.label}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="quetionnaireState"
          label="问卷状态"
        >
          <template slot-scope="scope">
            <template v-for="(item,index) in QuestionnaireStateList">
              <span
                :key="index"
                :style="{color:item.color}"
                v-if="item.value==scope.row.quetionnaireState"
              >{{ item.label}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="290"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.questionnaireLaunchState!==1"
              @click="launch(scope.row.id)"
              type="success"
              size="mini"
              plain
            >投放</el-button>
            <el-button
              @click="stopLaunch(scope.row.id)"
              v-if="scope.row.questionnaireLaunchState===1"
              type="danger"
              size="mini"
              plain
            >暂停</el-button>
            <el-button
              v-if="scope.row.questionnaireLaunchState!==1"
              @click="openSetting(scope.row)"
              size="mini"
              plain
            >设置</el-button>
            <el-button
              @click="openDes(scope.row)"
              size="mini"
              plain
            >详情</el-button>
            <el-button
              @click="copy(scope.row)"
              size="mini"
              plain
            >复制</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      >
      </el-pagination>
    </div>
    <settingDialog
      v-if="dialogVisible"
      :show.sync="dialogVisible"
      :dataObj="dataObj"
    ></settingDialog>
    <helpDesDialog
      v-if="dialogDesVisible"
      :showDes.sync="dialogDesVisible"
      :desObj="desObj"
    ></helpDesDialog>
  </div>
</template>

<script>
import { getUsual, launch, stopLaunch, copy } from 'api/request'
import settingDialog from './components/settingDialog'
import helpDesDialog from './components/helpDesDialog'
import { SetTableH } from '../../utils/utils'
export default {
  data() {
    return {
      loading: true,
      tableH: '250',
      dialogVisible: false,
      dialogDesVisible: false,
      dataObj: null,
      desObj: null,
      batchFlog: true,
      formInline: {
        LaunchState: -1,
        QuestionnaireState: -1,
        LaunchStartDate: '',
        LaunchEndDate: '',
        SearchTerm: '',
      },
      settingForm: {
        amount: 0,
        price: 0,
        dateOfStopLaunch: null,
      },
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10,
      },
      LaunchStateList: [
        {
          value: -1,
          label: '全部',
          color: '',
        },
        {
          value: 0,
          label: '未投放',
          color: '#f56c6c',
        },
        {
          value: 1,
          label: '投放中',
          color: '#67c23a',
        },
        {
          value: 2,
          label: '暂停投放',
          color: '#e6a23c',
        },
      ],
      QuestionnaireStateList: [
        {
          value: -1,
          label: '全部',
          color: '',
        },
        {
          value: 0,
          label: '未发布',
          color: '#f56c6c',
        },
        {
          value: 1,
          label: '已发布',
          color: '#67c23a',
        },
        {
          value: 3,
          label: '已暂停',
          color: '#e6a23c',
        },
      ],
      quesList: [],
      multipleIds: '',
    }
  },
  components: {
    settingDialog,
    helpDesDialog,
  },
  methods: {
    handleSelectionChange(val) {
      let multipleArr = val
      this.multipleIds = ''
      if (multipleArr.length) {
        this.batchFlog = false
        for (let i = 0; i < multipleArr.length; i++) {
          if (i == 0) {
            this.multipleIds = multipleArr[i].id + ''
          } else {
            this.multipleIds += ',' + multipleArr[i].id
          }
          if (multipleArr[i].quetionnaireState != 1) {
            this.batchFlog = true
            this.$message({
              type: 'warning',
              message: '您选中要投放的问卷还没发布,请选择合适的问卷投放',
            })
            return
          }
        }
      } else {
        this.batchFlog = true
      }
    },
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      this.getQuesList()
    },
    handleCurrentChange(val) {
      this.pageObj.PageIndex = val
      this.getQuesList()
    },
    reset() {
      for (let key in this.formInline) {
        if (key === 'LaunchState' || key === 'QuestionnaireState') {
          this.formInline[key] = -1
        } else {
          this.formInline[key] = ''
        }
      }
      this.handleCurrentChange(1)
    },
    async getQuesList() {
      let params = {
        PageIndex: this.pageObj.PageIndex,
        PageSize: this.pageObj.PageSize,
        LaunchState: this.formInline.LaunchState,
        QuestionnaireState: this.formInline.QuestionnaireState,
        LaunchStartDate: this.formInline.LaunchStartDate
          ? this.formInline.LaunchStartDate
          : null,
        LaunchEndDate: this.formInline.LaunchEndDate
          ? this.formInline.LaunchEndDate
          : null,
        SearchTerm: this.formInline.SearchTerm
          ? this.formInline.SearchTerm
          : null,
      }
      this.loading = true
      let data = await getUsual(params)
      if (data) {
        this.quesList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    },
    async launch(id) {
      this.$confirm('将向符合条件的微信用户推送答题通知', '是否确定投放?', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success',
        beforeClose: (action, instance, done) => {
          if (action == 'confirm') {
            instance.type = null
            instance.message = `<span class="el-icon-loading" style="color:#049EA3;margin-right:10px"></span><span>正在推送微信答题通知</span>`
            instance.$children[1].$el.disabled = true
            launch(id).then((data) => {
              if (data) {
                instance.type = 'success'
                instance.message = '已推送成功'
                done()
                setTimeout(() => {
                  instance.$children[1].$el.disabled = false
                }, 500)
                this.$message({
                  message: '投放成功',
                  type: 'success',
                })
                this.getQuesList()
              }else{
                instance.$children[1].$el.disabled = false;
                done();
              }
            }).catch(error=>{
              instance.$children[1].$el.disabled = false;
              done();
            })
          } else {
            done()
          }
        },
      })
        .then(() => {})
        .catch(() => {})
    },
    async stopLaunch(id) {
      this.$confirm('暂停投放用户将无法答题', '是否确定暂停投放?', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action == 'confirm') {
            instance.type = null
            instance.message = `<span class="el-icon-loading" style="color:#049EA3;margin-right:10px"></span><span>正在暂停问卷的投放</span>`
            instance.$children[1].$el.disabled = true
            stopLaunch(id).then((data) => {
              if (data) {
                instance.type = 'warning'
                instance.message = '已暂停投放'
                done()
                setTimeout(() => {
                  instance.$children[1].$el.disabled = false
                }, 500)
                this.$message({
                  message: '已暂停投放',
                  type: 'warning',
                })
                this.getQuesList()
              }else{
                instance.$children[1].$el.disabled = false;
                done();
              }
            }).catch(error=>{
              instance.$children[1].$el.disabled = false;
              done();
            })
          } else {
            done()
          }
        },
      })
        .then(() => {})
        .catch(() => {})
    },
    async copy(row) {
      this.$confirm(
        `复制问卷：${row.questionnaireTitle}`,
        '是否确定复制该份问卷?',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success',
          beforeClose: (action, instance, done) => {
            if (action == 'confirm') {
              // instance.type = null
              // instance.message = `<span class="el-icon-loading" style="color:#049EA3;margin-right:10px"></span><span>正在推送微信答题通知</span>`
              instance.$children[1].$el.disabled = true
              copy(row.id).then((data) => {
                if (data) {
                  instance.type = 'success'
                  instance.message = '已复制成功'
                  done()
                  setTimeout(() => {
                    instance.$children[1].$el.disabled = false
                  }, 500)
                  this.$message({
                    message: '已复制成功',
                    type: 'success',
                  })
                  this.getQuesList()
                }else{
                  instance.$children[1].$el.disabled = false;
                }
              }).catch(error=>{
                instance.$children[1].$el.disabled = false;
                done();
              })
            } else {
              done()
            }
          },
        }
      )
        .then(() => {})
        .catch(() => {})
    },
    openSetting(data) {
      this.dataObj = data
      this.dialogVisible = true
    },
    openDes(data) {
      this.desObj = data
      this.dialogDesVisible = true
    },
    toDes(id) {
      this.$router.push({
        path: '/projectDes',
        query: { id: id },
      })
    },
  },
  mounted() {
    SetTableH(this)
  },
  created() {
    this.getQuesList()
  },
}
</script>
<style lang='scss'>
#mutualHelpList {
  height: 100%;
  width: 100%;
  .formBox {
    width: 200px;
  }
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
